import { useT } from '../../i18n/context'
import { Button } from './Button'
import { Dialog } from './Dialog'

/**
 * Bestätigungs-Dialog statt nativer confirm()/alert()-Popups
 * (Owner-Vorgabe: Browser-Dialoge sind in der App verboten).
 */
export function ConfirmDialog({
    open,
    message,
    confirmLabel,
    tone = 'danger',
    loading = false,
    onConfirm,
    onClose,
}: {
    open: boolean
    message: string
    confirmLabel: string
    tone?: 'danger' | 'primary'
    loading?: boolean
    onConfirm: () => void
    onClose: () => void
}) {
    const t = useT()
    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('common.pleaseConfirm')}
        >
            <p className='text-sm text-slate-600 dark:text-slate-300'>
                {message}
            </p>
            <div className='mt-4 flex justify-end gap-2'>
                <Button type='button' variant='secondary' onClick={onClose}>
                    {t('common.cancel')}
                </Button>
                <Button
                    type='button'
                    variant={tone === 'danger' ? 'danger' : 'primary'}
                    loading={loading}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </div>
        </Dialog>
    )
}
